export default function getUrl(path: string, psm?: string) {
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    if (path.startsWith('/cloud/api')) {
      return path
    }
    // return `/api${path}`
    return path
  }

  // 浏览器环境
  if (typeof window !== 'undefined') {
    return path
  }

  const domain =
    psm &&
    process.env.NODE_ENV !== 'development' &&
    process.env.TCE_HOST_ENV !== 'boe'
      ? `consul://${psm}`
      : 'https://www.dongchedi.com'

  return `${domain}${path}`
}
